var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSterlingLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 108,
    viewBox: "0 0 100 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1505_25191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.4441 75.7955L31.3672 40.9355L35.4644 41.0027L76.2351 71.8326L77.4441 75.7955Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2131 90.8409L15.7173 40.5996L19.8145 40.6668L81.0041 86.8108L82.2131 90.8409Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9819 105.82L0 40.1973L4.16438 40.3316H4.23155L85.7729 101.924L86.9819 105.82Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1134 70.8253L32.2402 73.2434L21.4934 105.014L18.0679 107.499L30.2252 71.6314L30.964 69.3477L31.367 69.482L33.1134 70.8253Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6364 76.4687L39.8304 78.8867L33.9196 96.0816L30.6284 98.4996L37.7482 77.3419L38.5542 74.9238L38.6885 74.991L40.6364 76.4687Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8904 81.9078L47.0844 84.3258L46.0097 87.5499L42.6514 89.9679L45.0694 82.8481L45.8082 80.5645L46.2112 80.6988L47.8904 81.9078Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6821 4.0613L43.8606 38.854L43.0546 41.2721L41.0396 39.7272L41.9127 37.3764L54.5402 0.03125V0.0984175L55.6821 4.0613Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0477 18.6367V18.7039L51.2488 44.4962L50.4428 46.9142L48.4277 45.3694L49.3009 42.9513L58.8387 14.6738L60.0477 18.6367Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.548 33.7497V33.8168L59.0403 50.2729L58.1671 52.6909L56.2192 51.146L57.0252 48.728L63.4062 29.9883L64.548 33.7497Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6007 41.6746L66.7647 56.1156L65.9587 58.5336L63.8765 56.9888L64.6825 54.5707L69.1155 41.6074L71.6007 41.6746Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0039 41.743L74.22 61.7589L73.414 64.1769L71.3989 62.632L72.2049 60.214L78.5187 41.6758L81.0039 41.743Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2061 41.8094L83.7581 61.0864H83.6909L80.3325 63.4373L87.6538 41.7422L90.2061 41.8094Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2062 41.9429L95.4448 52.9584L92.0864 55.3093L96.5866 41.8086L99.2062 41.9429Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1505_25191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99.2064,
    height: 107.468,
    fill: "white",
    transform: "translate(0 0.03125)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSterlingLogo);
export default __webpack_public_path__ + "static/media/SterlingLogo.762f8588548451130be20901af01342d.svg";
export { ForwardRef as ReactComponent };